export interface PersonalDetails {
  name: string;
  date_of_birth: string;
  marital_status: 'Single' | 'Married' | 'Divorced' | 'Widowed' | 'Separated';
  nationality: string;
  languages_known: string[];
  mobile_numbers: string[];
  email: string;
  external_profile_url?: string;
  address: string;
  present_location: string;
}

export interface ProfessionalExperience {
  company: string;
  location: string;
  from: string;
  to: string;
  title: string;
  responsibilities: string[];
  notable_achievements: string[];
}

export interface VolunteerExperience {
  organization: string;
  title: string;
  location: string;
  from: string;
  to: string;
  responsibilities: string[];
}

export interface Education {
  institution: string;
  attendance: string;
  degree_type: string;
  specialization: string;
  gpa: string;
}

export interface Skill {
  skill: string;
}

export interface Training {
  skill: string;
  training_name: string;
  training_institution: string;
  date: string;
  skills_acquired: string[];
  description: string;
}

export interface Reference {
  name: string;
  title: string;
  company: string;
  mobile: string;
  email: string;
}

export interface Publication {
  publication_title: string;
  publication_date: string;
  publication_organization: string;
  publication_description: string;
}

export interface Certification {
  certification_name: string;
  certification_date: string;
  certification_organization: string;
}

export interface Profile {
  personal_details: PersonalDetails;
  profile_summary: string;
  professional_experience: ProfessionalExperience[];
  volunteer_experience: VolunteerExperience[];
  education: Education[];
  skills: Skill[];
  training: Training[];
  references: Reference[];
  publications: Publication[];
  certifications: Certification[];
}

export interface ProfileResponse {
  success: boolean;
  data?: {
    content: Profile;
  };
}

export interface SaveProfileRequest {
  data: Profile;
}

export const MARITAL_STATUS_OPTIONS = ['Single', 'Married', 'Divorced', 'Widowed', 'Separated'] as const;

export const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia',
  'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus',
  'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil',
  'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde',
  'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica',
  'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic',
  'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia',
  'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada',
  'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India',
  'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Ivory Coast', 'Jamaica', 'Japan', 'Jordan',
  'Kazakhstan', 'Kenya', 'Kiribati', 'North Korea', 'South Korea', 'Kosovo', 'Kuwait', 'Kyrgyzstan',
  'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
  'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands',
  'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro',
  'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand',
  'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine', 'Panama',
  'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania',
  'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines',
  'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
  'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa',
  'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland',
  'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago',
  'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates',
  'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela',
  'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
];

export const LANGUAGES = [
  'Arabic', 'Bengali', 'Chinese', 'Dutch', 'English', 'French', 'German', 'Greek', 'Hindi',
  'Italian', 'Japanese', 'Korean', 'Malayalam', 'Persian', 'Polish', 'Portuguese', 'Russian',
  'Spanish', 'Swedish', 'Tamil', 'Telugu', 'Turkish', 'Urdu', 'Vietnamese'
];